/**
 * Recorded in `enrichment_pipelines.criteria.source` by the daily re-enrichment
 * of tracked profiles (#519), and read back by the sessions UI to say that a
 * run was automatic. One constant for both sides: the backend writes it, the
 * frontend matches on it, and a rename that touched only one would silently
 * turn every automatic run back into "Requested by <admin>".
 */
export const MONITORED_AUTO_ENRICHMENT_SOURCE = 'monitored_auto_enrichment';
